import { forwardRef, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  IconButton,
  Slide,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import postMessage from '../../utils/postMessage';

const useStyles = makeStyles((theme) => ({
  defaultErrorScreenTypography: {
    textAlign: 'center',
  },
  dialogModal: {
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
    },
  },
  removeDeviceOrPaymentErrorScreen: {
    backgroundColor: theme.palette.custom.lightGrayishRed,
    borderRadius: '5px',
    borderColor: '#ebccd1',
    color: theme.palette.error.dark,
    fontSize: '14px',
    padding: '5px 10px',
    marginBottom: '20px',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '15px',
  },
  closeButton: {
    '&:hover': {
      backgroundColor: theme.palette.custom.white,
    },
  },
  closeIcon: {
    fontSize: '21px',
    fontWeight: '700',
    lineHeight: 1,
    textShadow: `0 1px 0 ${theme.palette.custom.white}`,
    padding: '3px 0',
    marginTop: '-60px',
    color: theme.palette.custom.black,
    opacity: '0.2',
    '&:hover': {
      opacity: '0.5',
    },
  },
  dialogContent: {
    padding: '15px',
  },
  dialogActions: {
    padding: '15px',
  },
  dialogActionButton: {
    width: '50%',
  },
}));

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

//Function can accept styling attribute as props that can be applied to Box Component
const ErrorScreen = ({
  error,
  color,
  classname,
  variant,
  removeStyle = false,
  errorDialog,
  subscriptionContainerClasses,
  dialogTitle,
  dialogContent,
  dialogActionButton,
  showErrorDialog,
  handleCloseErrorDialog,
  hideBackdrop,
  ...props
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(showErrorDialog);

  const errorScreenStyle =
    classname ||
    (removeStyle
      ? classes.removeDeviceOrPaymentErrorScreen
      : classes.defaultErrorScreenTypography);

  const handleClose = () => {
    setOpen(false);
    if (!hideBackdrop) {
      postMessage('module.hideBackdrop');
    }
    handleCloseErrorDialog();
  };

  useEffect(() => {
    if (!hideBackdrop) {
      postMessage('module.showBackdrop');
    }
  }, []);

  return errorDialog ? (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      maxWidth="lg"
      classes={{
        scrollPaper: subscriptionContainerClasses.topScrollPaper,
        paperScrollBody: subscriptionContainerClasses.topPaperScrollBody,
        paper: subscriptionContainerClasses.paper,
        className: classes.dialogModal,
      }}
      className={classes.dialogModal}
    >
      <Box className={classes.modalHeader}>
        <DialogTitle
          className={subscriptionContainerClasses.dialogTitle}
          disableTypography
        >
          <Typography variant="h2">{dialogTitle}</Typography>
        </DialogTitle>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
          disableRipple
          disableFocusRipple
          variant="text"
          size="small"
        >
          <CloseRoundedIcon className={classes.closeIcon} />
        </IconButton>
      </Box>
      <Divider />
      <DialogContent className={classes.dialogContent}>
        <Typography className={classes.dialogContentText}>
          {dialogContent}
        </Typography>
      </DialogContent>
      <Divider />
      <DialogActions classes={{ root: classes.dialogActions }}>
        <Button
          disableRipple
          disableFocusRipple
          size="small"
          variant="contained"
          className={classes.dialogActionButton}
          color="primary"
          onClick={handleClose}
        >
          <Typography variant="button">{dialogActionButton}</Typography>
        </Button>
      </DialogActions>
    </Dialog>
  ) : (
    <Box {...props}>
      <Typography variant={variant} color={color} className={errorScreenStyle}>
        {typeof error === 'string' ? error : null}
      </Typography>
    </Box>
  );
};

export default ErrorScreen;
